
import { Card } from "@/components/ui/card";
import { Navbar } from "@/components/layout/Navbar";
import { InitialRegistrationForm } from "@/components/auth/form/InitialRegistrationForm";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const Register = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('user_type, login_type')
          .eq('id', session.user.id)
          .single();

        if (profile?.login_type === 'admin' && profile?.user_type === 'admin') {
          navigate('/admin');
        }
      }
    };
    
    checkUser();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Créer votre compte
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Commencez par créer vos identifiants de connexion
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Card className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <InitialRegistrationForm />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Register;
